import axios, { HttpStatusCode } from 'axios';
import { useCallback } from 'react';

import { MIME_TYPES } from '@/constants';
import { logger } from '@/services/logger';
import { restUrl } from '@/services/utils';

const usePublicAsset = () => {

    const convertToPublicAsset = useCallback(async (assetPath: string): Promise<string> => {

        assetPath = encodeURI(assetPath);
        const convertToPublicAssetEndpoint = restUrl(`assetFolders/_convertToPublicAsset/${assetPath}`);
        const response = await axios.put(convertToPublicAssetEndpoint, null, {
            headers: {
                'Content-Type': MIME_TYPES.APPLICATION_JSON
            }
        });

        if (response.status === HttpStatusCode.Ok) {
            return response.data.publicAssetUrl;
        }

        logger.error('usePublicAsset: Could not convert asset folder to a public asset', response);
        throw new Error();

        // We only need one instance of this function.
        // eslint-disable-next-line
    }, []);

    return { convertToPublicAsset };

};

export { usePublicAsset };
